var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTextDocument = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 13 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43 1.157a.289.289 0 0 0-.286.286V8.19c0 .026 0 .052.013.078v1.365H.286A.289.289 0 0 1 0 9.347V.286C0 .13.13 0 .286 0h7.67c.156 0 .286.13.286.286v.884H6.916c-.026-.013-.065-.013-.104-.013H1.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.269 12.103c1.56 0 2.834-1.287 2.834-2.86 0-1.586-1.274-2.86-2.834-2.86S6.435 7.67 6.435 9.243s1.274 2.86 2.834 2.86Zm0 .897C11.323 13 13 11.31 13 9.23s-1.664-3.77-3.731-3.77c-.572 0-1.105.13-1.599.364a3.738 3.738 0 0 0-2.119 3.029c-.013.13-.013.26-.013.39C5.538 11.31 7.215 13 9.27 13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.531 8.528-2.626 2.574a.267.267 0 0 1-.377 0L7.02 9.516l.741-.728.754.858c.104.104.273.117.377.013L10.777 7.8l.754.728Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.211 2.847a.391.391 0 0 0-.39.39v6.565c0 .221.17.39.39.39H4.98c.091.416.234.793.43 1.157H1.962a.289.289 0 0 1-.286-.286V1.976c0-.156.13-.286.286-.286h7.683c.156 0 .286.13.286.286v2.86a5.257 5.257 0 0 0-.65-.052c-.169 0-.325.013-.494.026V3.237a.383.383 0 0 0-.39-.39H3.211Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54 5.148c-.052.026-.104.039-.143.065-.039.026-.078.039-.117.065H4.407a.391.391 0 0 1-.39-.39V4.51c0-.221.17-.39.39-.39h2.834c.208 0 .39.169.39.39v.377a.42.42 0 0 1-.09.26H7.54Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.344 5.915a4.473 4.473 0 0 0-.923 1.157H4.407a.391.391 0 0 1-.39-.39v-.377c0-.221.169-.39.39-.39h1.937Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11 7.774h-.703a.391.391 0 0 0-.39.39v.377c0 .22.17.39.39.39h.468c0-.052.013-.091.013-.143.04-.351.117-.702.221-1.014Z"
  })));
};
export { SvgTextDocument as ReactComponent };